var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filter-bar" }, [
    _c("div", { staticClass: "global-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("aside", { staticClass: "side-menu js-filter-menu" }, [
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.filters, function(filter, key, index) {
            return _c("filter-group", {
              key: key,
              attrs: { filter: filter, index: index }
            })
          }),
          1
        ),
        _vm._v(" "),
        _vm.secondaryfilters
          ? _c(
              "div",
              { staticClass: "row" },
              _vm._l(_vm.secondaryfilters, function(filter, key, index) {
                return _c("filter-group", {
                  key: key,
                  attrs: { filter: filter, index: index }
                })
              }),
              1
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn primary-btn js-toggle-filter-menu hide-desktop",
        attrs: { type: "button" }
      },
      [_vm._v("Sort & Filter "), _c("span", { staticClass: "icon-angle-down" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }